import _join from "lodash/join";

export function commaJoin(arr?: string[] | null): string {
  return _join(arr, ", ");
}
